import {Box3, Vector3} from "three";
import {toFixedFloat, toFixedVector} from "../../../../utils/utils";
import {HBEWallDefaultThickness} from "../../../../globals";

export class CombinedRoom {
    constructor(identifier, roomA, roomB, combinationDirection) {
        this.identifier = identifier;
        this.rooms = [];
        this.bounds = null;
        this.combinationDirection = combinationDirection;

        this.addRooms(roomA, roomB);

        //Y-Koordinate nicht relevant
        this.bounds.min.y = 0;
        this.bounds.max.y = 0;

        this.bounds.min = toFixedVector(this.bounds.min);
        this.bounds.max = toFixedVector(this.bounds.max);

        this.size = toFixedVector(this.bounds.getSize(new Vector3()));

        //Spannweite entspricht der Breite der Bounds (Innenkanten des Raums) + Einer Wandstärke (Halbe Wandstärke Auflagefläche pro Seite)
        this.spans = {
            x: toFixedFloat(this.size.x + HBEWallDefaultThickness),
            z: toFixedFloat(this.size.z + HBEWallDefaultThickness)
        };
    }

    addRooms(roomA, roomB) {
        this.bounds = new Box3().copy(roomA.bounds).union(roomB.bounds);
        if (roomA instanceof CombinedRoom && this.combinationDirection === roomA.combinationDirection) {
            this.rooms = [...roomA.rooms, roomB]; //Verlängerung des CombinedRoom in selbe Richtung
        } else if (roomB instanceof CombinedRoom && this.combinationDirection === roomB.combinationDirection) {
            this.rooms = [...roomB.rooms, roomA]; //Verlängerung des CombinedRoom in selbe Richtung
        } else {
            this.rooms = [roomA, roomB];
        }
    }
}
